import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule, } from '@progress/kendo-angular-dropdowns';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { CgpTabbedFormDialogModule } from '../cgp-tabbed-form-dialog/cgp-tabbed-form-dialog.module';
import { CgpFormDialogModule } from '../cgp-form-dialog/cgp-form-dialog.module';
import { CgpGridComponent } from './cgp-grid.component';
import { PipesModule } from '../pipes/pipes.module';

import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';

import { CgpTabbedFormDialogComponent } from '../cgp-tabbed-form-dialog/cgp-tabbed-form-dialog.component';

import { DialogModule } from '@progress/kendo-angular-dialog';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonGroupModule,
        ButtonsModule,
        ReactiveFormsModule,
        GridModule,
        ExcelModule,
        SwitchModule,
        AutoCompleteModule,
        MultiSelectModule,
        ComboBoxModule,
        DropDownListModule,
        NumericTextBoxModule,
        CgpFormDialogModule,
        CgpTabbedFormDialogModule,
        DialogModule,
        PipesModule,
    ],
    declarations: [
        CgpGridComponent,
    ],
    exports: [
        CgpGridComponent
    ],
    providers: []
})
export class CgpGridModule { }
